/*
 * Copyright (c) 2020, Neustar, Inc.
 * UNPUBLISHED PROPRIETARY SOURCE CODE
 *
 */

import { call, put } from "redux-saga/effects";
import _ from "lodash";
import axios from "../common/axios";
import actions from "../actionTypes";
import urls from "./URLS";
import localConfig from "../common/localConfig";
import getCookie from "../common/helpers/getCookie";
import { clearCookies } from "../common/helpers/getCookie";

export default function* loginRequest(action) {
  let absUrl;
  if (action.payload.mockApi) {
    absUrl = `${localConfig.contextPath}/${action.payload.endpoint}`;
  } else {
    absUrl = `${urls[action.payload.app]}/${action.payload.endpoint}`;
  }
  let key = `endpoints.${action.payload.app}.${action.payload.endpoint}.${action.method}`;
  let ajaxConfig = {
    method: action.method.toUpperCase(),
    headers: {
      "Content-Type": "application/json",
    },

    url: absUrl,
  };
  if (action.payload.appendToEndpoint) {
    ajaxConfig.url += action.payload.appendToEndpoint;
  }
  if (action.payload.params) {
    ajaxConfig.params = action.payload.params;
  }
  if (action.payload.data) {
    ajaxConfig.data = action.payload.data;
  }
  let isFetchingKey = `${key}.isFetching`;
  let responseKey = `${key}.response`;
  if (action.payload.keySuffix) {
    isFetchingKey = `${isFetchingKey}.${action.payload.keySuffix}`;
    responseKey = `${responseKey}.${action.payload.keySuffix}`;
  }
  yield put({
    type: actions.SET_IN_REDUX,
    payload: {
      path: isFetchingKey.split("."),
      data: true,
    },
  });
  try {
    let response = yield call(axios, ajaxConfig);
    if (
      response.status === 403 &&
      response.data.errorCode === "BAD_USERNAME_PASSWORD"
    ) {
      // yield put({
      //   type: actions.SET_IN_REDUX,
      //   payload: {
      //     path: responseKey.split("."),
      //     data: response.data,
      //   },
      // });
      // window.location = `${window.location.href}`;

      yield put({
        type: actions.SET_IN_REDUX,
        payload: {
          path: "endpoints.hasError".split("."),
          data: {
            show: true,
            type: "unauthorized",
            message: "Invalid Login! Please try again.",
          },
        },
      });
    }
    yield put({
      type: actions.SET_IN_REDUX,
      payload: {
        path: responseKey.split("."),
        data: response.data,
      },
    });
  } catch (e) {
    // debugger;
    console.error("e: ");
    console.error(e);
  } finally {
    // debugger;
    yield put({
      type: actions.SET_IN_REDUX,
      payload: {
        path: isFetchingKey.split("."),
        data: false,
      },
    });
  }
}
